module.exports = __webpack_public_path__ + "static/img/2-2.03c77b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/index-phone/2-2.png
// module id = xJbw
// module chunks = 7